/**
 * The linked event id on a document (US-37724).
 *
 * Estimate, WorkOrder and Invoice have all carried an `event` ObjectId for years —
 * API/models/Estimate/index.js:35, WorkOrder:50, Invoice:120 — and no client-portal read path
 * ever used it, so a client was never told the date their work was booked for.
 *
 * The ref may arrive as a bare id or, if a read path ever populates it, as an object. Both
 * shapes resolve to a string here so no caller has to care.
 */
export const eventIdOf = document => {
  const ref = document && document.event
  if (!ref) return null
  const id = ref._id || ref
  return typeof id === 'string' || typeof id === 'number' ? String(id) : null
}

export default eventIdOf
